<template>

	<el-container>
		<el-header>
			<vheader v-on:LoginBox="LoginBox" ref="VHeader"></vheader>
		</el-header>
		<el-main class="main-bg">
			<transition name="fade" mode="out-in">
				<router-view v-on:LoginBox="LoginBox" v-on:Pwd="Pwd" v-on:HeaderMenu="HeaderMenu"></router-view>
			</transition>
			<!-- <el-container class="container user-container">
				<el-aside class="left-column">
					<user-menu v-on:LoginBox="LoginBox" v-on:HeaderMenu="HeaderMenu"></user-menu>
				</el-aside>

				<el-main class="right-column">
					<router-view v-on:LoginBox="LoginBox" v-on:HeaderMenu="HeaderMenu"></router-view>
				</el-main>	
			</el-container>		 -->
		</el-main>
		<el-footer height="176px" style="background-color: #645e5e;">
			<vfooter></vfooter>
		</el-footer>
		<LoginBox ref="LoginBox"></LoginBox>
		<Pwd ref="Pwd"></Pwd>
	</el-container>
</template>

<script>
import Header from '@/components/Header'
import Menu from '@/components/views/user/Menu.vue'
import Footer from '@/components/Footer'
import LoginBox from '@/components/LoginBox'
import Pwd from '@/components/PasswordBox'
import FloatButton from '@/components/FloatButton'
import { globalMixin } from '@/mixin.js';
import { mapGetters } from 'vuex'
export default {
    mixins: [globalMixin],
	name: 'DefaultLayout',
	components: {
		'vheader': Header,
		'vfooter': Footer,
		'userMenu': Menu,
		'LoginBox' : LoginBox,
		'Pwd' : Pwd,
		'FloatButton' : FloatButton,
	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
			web: 'web',
		}),
    },
		/*
	provide() {
		return {
			'LoginBox' : LoginBox
		}
	},*/
	methods: {
		LoginBox(args){
			this.$refs.LoginBox[args.methods]();
		},
		Pwd(args){
			this.$refs.Pwd[args.methods]();
		},
		HeaderMenu(args){
			//this.$refs.VHeader.activeIndex = '/slot';
			this.$refs.VHeader['handleSelect'](args) ;
			console.log(this.$refs.VHeader);
		},
	},
	created() {


	},
	mounted() {

	},

}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transform: translateX(0px);
  opacity: 1;
  transition: all 0.2s ease-in-out;
}
.fade-enter, 
.fade-leave-to {
  opacity: 0;
  transform: translateX(-5px);
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/Default2.vue